(() => {
  const countryFlag = (iso) => {
    if (!iso || iso.length !== 2) return '';
    const code = iso.toUpperCase();
    return Array.from(code)
      .map((c) => String.fromCodePoint(127397 + c.charCodeAt(0)))
      .join('');
  };

  const addBusinessDays = (start, days, includeWeekend) => {
    const date = new Date(start.getTime());
    let remaining = Number(days) || 0;
    while (remaining > 0) {
      date.setDate(date.getDate() + 1);
      const day = date.getDay();
      if (includeWeekend || (day !== 0 && day !== 6)) remaining -= 1;
    }
    return date;
  };

  const formatReceiveDate = (date) =>
    date.toLocaleDateString(undefined, {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
    });

  const initShipping = (root) => {
    if (!root || root.dataset.ssReady) return;
    root.dataset.ssReady = '1';

    const days = Number(root.dataset.days || 5);
    const includeWeekend = root.dataset.includeWeekend === 'true';
    const country = (root.dataset.country || '').toUpperCase();
    const allowAll = root.dataset.allowAll === 'true';
    const allowed = (root.dataset.allowed || '')
      .split(',')
      .map((c) => c.trim().toUpperCase())
      .filter(Boolean);

    const receiveEl = root.querySelector('[data-ss-receive-date]');
    if (receiveEl) {
      receiveEl.textContent = formatReceiveDate(
        addBusinessDays(new Date(), days, includeWeekend)
      );
    }

    const fastTextEl = root.querySelector('[data-ss-fast-text]');
    const flagEl = root.querySelector('[data-ss-flag]');
    const truckEl = root.querySelector('.ss-shipping__truck');
    if (!fastTextEl) return;

    const inAllowed = allowAll || allowed.includes(country);
    let template = inAllowed
      ? root.dataset.fastTemplate || 'COUNTRY_FLAG <strong>Fast</strong> COUNTRY_CODE Shipping'
      : root.dataset.fastRest || 'Fast International Shipping';

    const flag = countryFlag(country);
    if (flagEl) {
      flagEl.textContent = template.includes('COUNTRY_FLAG') ? flag : '';
      flagEl.hidden = !flagEl.textContent;
    }
    if (truckEl) {
      truckEl.hidden = Boolean(flagEl && !flagEl.hidden && flagEl.textContent);
    }

    template = template
      .replace(/COUNTRY_FLAG/g, '')
      .replace(/COUNTRY_CODE/g, country || '')
      .replace(/\s+/g, ' ')
      .trim();

    fastTextEl.innerHTML = template;
  };

  const initTabs = (root) => {
    if (!root || root.dataset.ssReady) return;
    root.dataset.ssReady = '1';
    const tabs = [...root.querySelectorAll('[data-ss-tab]')];
    const panels = [...root.querySelectorAll('[data-ss-panel]')];
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const id = tab.getAttribute('data-ss-tab');
        tabs.forEach((t) => {
          const active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach((p) => {
          p.classList.toggle('is-active', p.getAttribute('data-ss-panel') === id);
        });
      });
    });
  };

  const initAtc = (configEl) => {
    if (!configEl || configEl.dataset.ssReady) return;
    configEl.dataset.ssReady = '1';
    let config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (e) {
      return;
    }

    const section = document.getElementById(`shopify-section-${config.sectionId}`);
    if (!section) return;
    const button = section.querySelector('.product-form__submit');
    const buttonsWrap = section.querySelector('.product-form__buttons');
    if (!button) return;

    button.classList.add('ss-atc-button');
    if (buttonsWrap) buttonsWrap.classList.add('ss-atc-styled');
    if (String(config.lift || '').includes('lift')) button.classList.add('ss-atc-lift');
    if (String(config.shine || '').includes('shine')) button.classList.add('ss-atc-shine');

    const span = button.querySelector('span') || button;
    const label = config.label || 'Add to cart';
    let html = `${config.iconHtml || ''}<span class="ss-atc-button__label">${label.toUpperCase()}`;
    if (config.showPrice && config.price) {
      html += ` - ${config.price}`;
      if (config.compare) {
        html += ` <span class="ss-atc-button__compare">${config.compare}</span>`;
      }
    }
    html += '</span>';
    span.innerHTML = html;
  };

  const initDescription = (root) => {
    if (!root || root.dataset.ssReady) return;
    root.dataset.ssReady = '1';

    const content = root.querySelector('[data-ss-desc-content]');
    const toggle = root.querySelector('[data-ss-desc-toggle]');
    const label = root.querySelector('[data-ss-desc-toggle-label]');
    const icon = root.querySelector('.ss-description__toggle-icon');
    if (!content || !toggle || !label) return;

    const lines = Number(root.dataset.collapsedLines || 4);
    const lineHeight = parseFloat(getComputedStyle(content).lineHeight) || 22;
    const collapsedHeight = Math.max(lineHeight * lines, 88);
    const moreLabel = root.dataset.readMore || 'Read more';
    const lessLabel = root.dataset.readLess || 'Read less';

    requestAnimationFrame(() => {
      const fullHeight = content.scrollHeight;
      if (fullHeight <= collapsedHeight + 8) {
        toggle.hidden = true;
        return;
      }

      toggle.hidden = false;
      content.style.maxHeight = `${collapsedHeight}px`;
      content.classList.add('is-collapsed');
      label.textContent = moreLabel;
      if (icon) icon.textContent = '+';

      toggle.addEventListener('click', () => {
        const expanded = root.classList.toggle('is-expanded');
        if (expanded) {
          content.style.maxHeight = `${content.scrollHeight}px`;
          content.classList.remove('is-collapsed');
          label.textContent = lessLabel;
          if (icon) icon.textContent = '–';
        } else {
          content.style.maxHeight = `${collapsedHeight}px`;
          content.classList.add('is-collapsed');
          label.textContent = moreLabel;
          if (icon) icon.textContent = '+';
        }
      });
    });
  };

  const boot = () => {
    document.querySelectorAll('[data-ss-shipping]').forEach(initShipping);
    document.querySelectorAll('[data-ss-tabs]').forEach(initTabs);
    document.querySelectorAll('[id^="ss-atc-config-"]').forEach(initAtc);
    document.querySelectorAll('[data-ss-description]').forEach(initDescription);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
